var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowYellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.39922 5.9998L6.29922 2.0998C6.48255 1.91647 6.57422 1.68314 6.57422 1.3998C6.57422 1.11647 6.48255 0.883138 6.29922 0.699805C6.11589 0.516471 5.88255 0.424805 5.59922 0.424805C5.31589 0.424805 5.08255 0.516471 4.89922 0.699805L0.299219 5.2998C0.199219 5.3998 0.128385 5.50814 0.0867186 5.6248C0.0450521 5.74147 0.0242186 5.86647 0.0242186 5.9998C0.0242186 6.13314 0.0450521 6.25814 0.0867186 6.3748C0.128385 6.49147 0.199219 6.5998 0.299219 6.6998L4.89922 11.2998C5.08255 11.4831 5.31589 11.5748 5.59922 11.5748C5.88255 11.5748 6.11589 11.4831 6.29922 11.2998C6.48255 11.1165 6.57422 10.8831 6.57422 10.5998C6.57422 10.3165 6.48255 10.0831 6.29922 9.89981L2.39922 5.9998Z",
    fill: "#EAD40C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowYellow);
export default __webpack_public_path__ + "static/media/arrow-yellow.a692331d0a10cda335b8f5468875ce99.svg";
export { ForwardRef as ReactComponent };